export const SAVE_PROFILE_DATA = "SAVE_PROFILE_DATA";
export const SAVE_IP_ADDRESS = "SAVE_IP_ADDRESS";
export const UPDATE_PROGRESS_POSTS = "UPDATE_PROGRESS_POSTS";
export const UPDATE_PROGRESS_VIEWS = "UPDATE_PROGRESS_VIEWS";
export const UPDATE_CHAT_ENABLED = "UPDATE_CHAT_ENABLED";
